import { createSlice } from "@reduxjs/toolkit";

export const doNotContactSlice = createSlice({
    name : 'dnc',
    initialState : {
        doNotContactState : false
    },
    reducers:{
        setDoNotContactState : (state , action)=>{
         state.doNotContactState = action.payload;
        }
    }
})

export const {setDoNotContactState} = doNotContactSlice.actions
export default doNotContactSlice.reducer;